import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PointsActions } from "store/ducks/multipliers";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Points/Multipliers/components";
import { useDefaultDateFormat } from "helpers";

class Clone extends Component {
  state = {
    data: {
      description: "",
      multiplier: "",
      start_at: "",
      end_at: "",
      observation: "",
      send_email: false,
      store_channels: [],
      store_channels_all: true,
      store_region_ids: [],
      store_region_ids_all: true,
      extra_data: {
        store_region: null,
        store_places: [],
        store_places_all: true,
        classification_passions: [],
        classification_passions_all: true,
        store_product_types: [],
        store_product_types_all: true,
        store_sections: [],
        store_sections_all: true,
        store_sub_sections: [],
        store_sub_sections_all: true,
        store_groups: [],
        store_sub_groups: [],
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        send_email: true,
        all_products: false,
      },
    },
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Campanha de pontos", to: "/points/multiplier" },
      { name: "Adicionar Novo (Clone)", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      description: {
        required: true,
      },

      multiplier: {
        required: true,
      },

      start_at: {
        required: true,
      },

      end_at: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = async () => {
    const isValidForm = this.handleValidate();

    if (!isValidForm) {
      return;
    }

    const { data } = this.state;
    const { createMultiplierRequest } = this.props;


    const formData = {
      points_campaign: {
        description: data.description,
        multiplier: data.multiplier,
        start_at: useDefaultDateFormat(data.start_at),
        end_at: useDefaultDateFormat(data.end_at),
        store_channel_ids: data.store_channels_all
          ? []
          : data.store_channels.map((channel) => channel.value),
        store_region_ids: data.store_region !== undefined
          ? [data.store_region.value]
          : [],
        extra_data: data.extra_data,
      },
    };

    createMultiplierRequest(formData);
  };

  componentDidMount() {
    const { cloneData } = this.props.location.state

    if (cloneData) {
      this.setState({
        data: cloneData
      })
    }
  }

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { clone } = this.props;


    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={clone.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

Clone.propTypes = {
  location: {
    state: {
      data: {
        title: PropTypes.string,
        description: PropTypes.string,
        alias: PropTypes.string,
        experience_voucher_configuration_id: PropTypes.string,
        experience_commercial_campaigns_id: PropTypes.string,
        discount: PropTypes.string,
        value: PropTypes.number,
        activation_period: PropTypes.bool,
        start_at: PropTypes.string,
        end_at: PropTypes.string,
        activation_limit: PropTypes.number,
        active: PropTypes.bool,
        app_only: PropTypes.bool,
        store_channels: PropTypes.bool,
        store_channels_all: PropTypes.bool,
        cpf_list: PropTypes.array,
        promoted: PropTypes.bool,
        extra_data: {
          store_region: PropTypes.string,
          store_places: PropTypes.array,
          store_places_all: PropTypes.bool,
          classification_passions: PropTypes.array,
          classification_passions_all: PropTypes.bool,
          store_product_types: PropTypes.array,
          store_product_types_all: PropTypes.bool,
          store_sections: PropTypes.array,
          store_sections_all: PropTypes.bool,
          store_sub_sections: PropTypes.array,
          store_sub_sections_all: PropTypes.bool,
          store_groups: PropTypes.array,
          store_sub_groups: PropTypes.array,
          remove_mdh: PropTypes.bool,
          add_mdh: PropTypes.bool,
          add_store_products: PropTypes.array,
          remove_store_products: PropTypes.array,
          send_email: PropTypes.bool,
          all_products: PropTypes.bool,
        },
      },
      errors: PropTypes.object,
      breadcrumbs: PropTypes.array,
    },
  },
  ...PointsActions,
  clone: PropTypes.object,
}

const mapState = (state) => ({
  clone: state.multipliers.create,
});

const mapActions = (dispatch) => bindActionCreators(PointsActions, dispatch);

export default connect(mapState, mapActions)(Clone);
